/**
 * 外部キー修復の結果をSentryへ報告する。
 * 顧客データを削除した事実と、削除しなかった違反の存在を必ず可視化する。
 */
import { captureMessage, withScope } from '@sentry/react'
import type { ForeignKeyRepairResult } from './repairForeignKeyViolations'

/**
 * 修復結果をSentryへ送信する。違反が無かった場合は何も送らない。
 * 報告失敗はmigration完了を妨げない。
 * @param params - result: 外部キー修復の結果。
 */
export const reportForeignKeyRepair = async ({
  result,
}: {
  readonly result: ForeignKeyRepairResult
}): Promise<void> => {
  if (result.deletedCount === 0 && result.skipped.length === 0) {
    return
  }

  try {
    withScope((scope) => {
      scope.setContext('portfolioForeignKeyRepair', {
        deletedCount: result.deletedCount,
        deletedCountByRelation: result.deletedCountByRelation,
        deletedRows: result.deletedRows,
        // CASCADE連鎖を含む実削除数。バックアップ照合にはこちらを使う
        removedRowsTotal: result.removedRowsTotal,
        removedRowsByTable: result.removedRowsByTable,
        skipped: result.skipped,
        rounds: result.rounds,
        unconverged: result.unconverged,
      })
      // 未修復の違反が残るケースと収束しなかったケースは調査対象としてerror、
      // 修復だけが行われたケースはデータ変更の記録としてwarningにする
      scope.setLevel(
        result.skipped.length > 0 || result.unconverged ? 'error' : 'warning',
      )
      captureMessage(
        `portfolio foreign key repair: removed ${result.removedRowsTotal} rows (direct ${result.deletedCount}), unresolved ${result.skipped.length}`,
      )
    })
  } catch {
    // Sentry送信の失敗はmigrationを妨げない
  }
}
